import {useSelector} from 'react-redux';
import {UiWiseWidgetState} from 'shared/constants/UiWiseConst';

export const useWidget = (widgetId) => {
  const widgetState = useSelector(
    ({widgetReducer}) =>
      widgetReducer.widgetStateById[widgetId] || UiWiseWidgetState.INIT,
  );

  const widgetData = useSelector(
    ({widgetReducer}) => widgetReducer.widgetDataById[widgetId] || null,
  );

  // console.log(`>>> [useWidget] widgetId: ${widgetId} -> ${widgetState} `);

  return {
    widgetData: widgetData,
    widgetState: widgetState,
    isInit: widgetState === UiWiseWidgetState.INIT,
    isLoading: widgetState === UiWiseWidgetState.LOADING,
    isSuccess: widgetState === UiWiseWidgetState.SUCCESS,
    isError: widgetState === UiWiseWidgetState.ERROR,
  };
};
